import { createSlice } from '@reduxjs/toolkit';
import { fetchText } from './features';

export const adminAnalyzer = createSlice({
  name: 'adminAnalyzer',
  initialState: {
    textForm: null,
    isLoading: false,
    isError: false,
    textType: 'NON_TRANSLATED',
    orderId: null,
    orderType: null,
    orderContentType: null,
    orderSiloName: '',
    orderWebsite: '',
    assistantId: null,
    orderContentType: null,
  },
  reducers: {
    clearTextState: (state) => {
      state.textForm = null;
      state.isLoading = false;
      state.isError = false;
    },
    updateForm: (state, { payload }) => {
      state.textForm = payload;
      state.isLoading = false;
      state.isError = false;
    },
    updateTextForm: (state, { payload }) => {
      let object = { ...state.textForm };
      object[payload.key] = payload.value;
      state.textForm = { ...object };
    },
    setOrderId: (state, { payload }) => {
      state.orderId = payload;
    },
    setOrderType: (state, { payload }) => {
      state.orderType = payload;
    },
    setOrderWebsite: (state, { payload }) => {
      state.orderWebsite = payload;
    },
    setTextType: (state, { payload }) => {
      state.textType = payload;
    },
    setAssistantId: (state, { payload }) => {
      state.assistantId = payload;
    },
    setOrderContentType: (state, { payload }) => {
      state.orderContentType = payload;
    },
    setAdminOrderSiloName: (state, { payload }) => {
      state.orderSiloName = payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchText.fulfilled, (state, { payload }) => {
        state.textForm = payload;
        state.isLoading = false;
      })
      .addCase(fetchText.pending, (state, { payload }) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(fetchText.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export default adminAnalyzer.reducer;

export const {
  clearTextState,
  updateForm,
  updateTextForm,
  setOrderId,
  setOrderType,
  setTextType,
  setAssistantId,
  setOrderContentType,
  setAdminOrderSiloName,
  setOrderWebsite,
} = adminAnalyzer.actions;
export const adminAnalyzerSelector = (state) => state.adminAnalyzer;
